module.exports = __webpack_public_path__ + "img/changeFineness-1.7bce771.webp";